import React, {useState, useEffect} from 'react';
import Cookies from 'utils/cookies';

// import LoginPassword from './LoginPassword';
// import Login2FAEmailGuard from './Login2FAEmailGuard';
import LoginPassword from './LoginPassword';
import LoginEmail from './LoginEmail';
import Login2FA from './Login2FA';

function LoginDefault() {
  const [emailSession, setEmailSession] = useState(
    Cookies.emailSession || null
  );
  const [twoFactorSession, setTwoFactorSession] = useState(null);

  useEffect(() => {
    return () => {
      setTwoFactorSession(null);
      setEmailSession(null);
    };
  }, []);

  function removeEmailSession() {
    Cookies.emailSession = '';
    setEmailSession(null);
  }

  if (twoFactorSession) {
    return <Login2FA session={twoFactorSession} />;
  }

  if (emailSession) {
    return (
      <LoginPassword
        session={emailSession}
        onNext={setTwoFactorSession}
        onPrev={removeEmailSession}
      />
    );
  }

  if (!emailSession) {
    return <LoginEmail onNext={setEmailSession} />;
  }
}

export default LoginDefault;
